import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

export const skillVersionsQueryKey = (skillId: string | undefined) => [
  "skillVersions",
  skillId,
];

export function useSkillVersions(skillId: string | undefined) {
  const { skillService } = useDomainServices();

  return useQuery({
    queryKey: skillVersionsQueryKey(skillId),
    queryFn: ({ signal }) =>
      skillService.listVersions(skillId!, { abortSignal: signal }),
    enabled: skillId !== undefined,
    staleTime: 30_000,
  });
}
